var render = function render(_c,_vm){return _c('div',{directives:[{name:"state",rawName:"v-state",value:({ loading: _vm.props.loading }),expression:"{ loading: props.loading }"}],staticClass:"loading-wrapper"},[_vm._t("default"),_c('div',{staticClass:"loading-wrapper__overlay"}),_vm._m(0)],2)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"loading-wrapper__indicator"},[_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"loading"})])])
}]

export { render, staticRenderFns }